import * as React from "react";
import type { SVGProps } from "react";
const SvgFiles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#files_svg__a)">
      <path d="M19.5 9h-4a2 2 0 0 1-2-2V3a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2" />
      <path d="M17.5 18h-7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h4a1 1 0 0 1 .71.29l5 5a1 1 0 0 1 .29.71v7a3 3 0 0 1-3 3m-7-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V8.41L14.09 4z" />
      <path d="M13.5 22h-7a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2h-2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2a1 1 0 0 1 2 0v2a3 3 0 0 1-3 3" />
    </g>
    <defs>
      <clipPath id="files_svg__a">
        <path fill="#fff" d="M3.5 2h17v20h-17z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiles;
